(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
			this._inertedElements = [];
		}
		hide() {
			this.removeInert();
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			this.applyInert();
			const dialog = this.querySelector('[role="dialog"]');
			if (dialog) {
				dialog.focus();
			}
			this.constProductPageSwiperCall();
		}
		applyInert() {
			this._inertedElements = [];
			let current = this;
			while (current && current !== document.body) {
				const parent = current.parentElement;
				if (parent) {
					Array.from(parent.children).forEach((sibling) => {
						if (sibling === current) return;
						if (sibling.tagName === 'SCRIPT') return;
						if (!sibling.hasAttribute('inert')) {
							sibling.setAttribute('inert', '');
							sibling.setAttribute('aria-hidden', 'true');
							this._inertedElements.push(sibling);
						}
					});
				}
				current = parent;
			}
		}
		removeInert() {
			this._inertedElements.forEach((el) => {
				el.removeAttribute('inert');
				el.removeAttribute('aria-hidden');
			});
			this._inertedElements = [];
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


class ProductModal extends ModalDialog {
			constructor() {
				super();
				this._inertedElements = [];
			}
			hide() {
				this.removeFocusGuard();
				this.removeInert();
				super.hide();
				window.pauseAllMedia();
			}
			show(opener) {
				super.show(opener);
				this.applyInert();
				this.addFocusGuard();
				const closeBtn = this.querySelector('.product-media-modal__toggle');
				if (closeBtn) {
					closeBtn.focus();
				}
				this.constProductPageSwiperCall();
			}
			applyInert() {
				this._inertedElements = [];
				let current = this;
				while (current && current !== document.body) {
					const parent = current.parentElement;
					if (parent) {
						Array.from(parent.children).forEach((sibling) => {
							if (sibling === current) return;
							if (sibling.tagName === 'SCRIPT') return;
							if (!sibling.hasAttribute('inert')) {
								sibling.setAttribute('inert', '');
								sibling.setAttribute('aria-hidden', 'true');
								this._inertedElements.push(sibling);
							}
						});
					}
					current = parent;
				}
			}
			removeInert() {
				this._inertedElements.forEach((el) => {
					el.removeAttribute('inert');
					el.removeAttribute('aria-hidden');
				});
				this._inertedElements = [];
			}
			addFocusGuard() {
				const modal = this;
				this._focusGuard = (event) => {
					if (!modal.contains(event.target)) {
						event.stopPropagation();
						const focusable = getFocusableElements(modal);
						if (focusable.length) {
							focusable[0].focus();
						}
					}
				};
				this._tabGuard = (event) => {
					if (event.code.toUpperCase() !== 'TAB') return;
					const focusable = getFocusableElements(modal);
					if (!focusable.length) return;
					const first = focusable[0];
					const last = focusable[focusable.length - 1];
					if (event.shiftKey && event.target === first) {
						event.preventDefault();
						last.focus();
					} else if (!event.shiftKey && event.target === last) {
						event.preventDefault();
						first.focus();
					}
				};
				document.addEventListener('focusin', this._focusGuard);
				document.addEventListener('keydown', this._tabGuard);
			}
			removeFocusGuard() {
				if (this._focusGuard) {
					document.removeEventListener('focusin', this._focusGuard);
					this._focusGuard = null;
				}
				if (this._tabGuard) {
					document.removeEventListener('keydown', this._tabGuard);
					this._tabGuard = null;
				}
			}
			showActiveMedia() {
				this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
						element.classList.remove('active');
					}
				)
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
				if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
					activeMedia.loadContent();
			}
			
			constProductPageSwiperCall(showActiveMedia) {
				const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
				let activeMediaIndex = 0
				
				this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
						if(element == activeMedia){
							activeMediaIndex = index
						}
					}
				)
				const prodPageSwiper = new Swiper("#product-page-swiper", {
					zoom: true,
					centeredSlides: false,
					slidesPerView: 1,
					autoheight: true,
					watchSlidesVisibility: false,
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
					init: false,
					navigation: {
						nextEl: ".swiper-button-next-prod-page",
						prevEl: ".swiper-button-prev-prod-page",
					},
					pagination: {
						el: ".swiper-pagination-product-page",
						clickable: true,
					},
					//on: {
					//	click: function (e) {
					//			if (this.zoom.scale === 1) {
					//			this.zoom.in();
					//			} else {
					//				this.zoom.out();
					//			}
       		//	 },
					//},
				});
				function announceSlide(swiper) {
					const total = swiper.slides.length;
					const index = swiper.activeIndex + 1;
					const activeSlide = swiper.slides[swiper.activeIndex];
					const img = activeSlide ? activeSlide.querySelector('img') : null;
					const alt = img ? img.getAttribute('alt') || '' : '';
					const message = alt
						? 'Showing slide ' + index + ' of ' + total + ': ' + alt
						: 'Showing slide ' + index + ' of ' + total;
					const statusEl = document.getElementById('gallery-status');
					if (statusEl) {
						statusEl.textContent = message;
					}
				}
				prodPageSwiper.on('init', function() {
					prodPageSwiper.slideTo(activeMediaIndex, 0, false);
					announceSlide(prodPageSwiper);
				});
				prodPageSwiper.on('slideChange', function() {
					announceSlide(prodPageSwiper);
				});
				prodPageSwiper.init()
				document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
			}
		}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						const hasProducts =
							recommendations &&
							recommendations.querySelector('.product-recommendations__list li');

						if (hasProducts) {
							this.innerHTML = recommendations.innerHTML;
							return;
						}

						/* Sin recomendaciones de Shopify: usar el respaldo (mismo equipo o coleccion) */
						const fallback = this.querySelector('template[data-rec-fallback]');
						const target = this.querySelector('.product-recommendations__item');
						if (fallback && target && fallback.content.querySelector('li')) {
							target.appendChild(fallback.content.cloneNode(true));
							fallback.remove();
							return;
						}

						/* Sin recomendaciones ni respaldo: ocultar la seccion completa */
						const section = this.closest('.shopify-section') || this;
						section.style.display = 'none';
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function() {
		function appHeight() {
			const doc = document.documentElement
			doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
		}
		appHeight();
	});

  } catch(e) { console.error(e); }
})();
})();
